import { updateOnboarding, UpdateOnboardingPayload } from 'api/profiles'
import { useAuth } from 'contexts'
import { useUserProfile } from 'hooks/useUserProfile'
import { useMutation } from 'react-query'

export function useUpdateOnboarding() {
  const { user } = useAuth()
  const { refetch: refetchProfile } = useUserProfile()

  return useMutation({
    mutationFn: async (payload: UpdateOnboardingPayload) => {
      if (!user) {
        console.error('You must be authenticated')
        return
      }

      return updateOnboarding(user.id, payload)
    },
    onSuccess: async () => {
      await refetchProfile()
    },
  })
}
